import React from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import CustomTimePicker from './CustomTimePicker';
import { CustomCheckbox } from './CustomCheckbox';
import { ButtonNextStep } from './buttons/ButtonNavigation';
import CustomDaySelector from './CustomDaySelector';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * @Description Component for selecting days and time schedules.
 * @param Array dayArray: List of selected days (values from 0 to 6, where 0 = Sunday).(Required)
 * @param boolean allTime: Flag indicating if all time slots are selected. (Required)
 * @param Date fromValue: Start time value.(Required)
 * @param Date toValue: End time value.(Required)
 * @param Function setToValue: Function to update the end time.(Required)
 * @param Function handleCLick: Function triggered on button click.(Required)
 * @param Function setDayArray: Function to update the selected days.(Required)
 * @param Function setAllDays: Function to toggle all days selection. (Required)
 * @param Function setfromValue: Function to update the start time.(Required)
 * @param Function setAllTime: Function to toggle all time selection.(Required)
 * @returns JSX.Element
 */
const ScheduleSelectorDayTime = ({
    dayArray,
    allTime,
    fromValue,
    toValue,
    setToValue,
    handleCLick,
    setDayArray,
    setAllDays,
    setfromValue,
    setAllTime,
    emptyFields,
}) => {
    const { t } = useTranslation();

    const selectAllDays = (event) => {
        setAllDays(event.target.checked);
        if (event.target.checked) {
            setDayArray([1, 2, 3, 4, 5, 6, 0]);
        } else {
            setDayArray([]);
        }
    };
    const handleAllTime = (event) => {
        if (event.target.checked) {
            setfromValue(new Date('2014-08-18T00:00:00'));
            setToValue(new Date('2014-08-18T23:59:59'));
        } else {
            setfromValue(new Date('2014-08-18T00:00:00'));
            setToValue(new Date('2014-08-18T00:00:00'));
        }
        setAllTime(!allTime);
    };

    return (
        <div className='col-lg-6'>
            <div className='d-flex justify-content-between'>
                <div>
                    <span className='schedule-heading'>{t('schedule')}</span>
                    <span className='schedule-heading-sub-heading'>{t('to_open_the_door')}</span>
                </div>

                <CustomCheckbox
                    trans='all_days'
                    checked={dayArray.length > 0 && dayArray.length === 7}
                    onChange={selectAllDays}
                    size='small'
                />
            </div>
            <CustomDaySelector dayArray={dayArray} setDayArray={setDayArray} containerClasses={"no-width"}/>
            <div className='col-md-12 p-0'>
                <div className='mt-2 access_text'>
                    <CustomCheckbox
                        trans='all_time'
                        checked={allTime}
                        onChange={handleAllTime}
                        size='small'
                    />
                </div>
                <div className='d-flex flex-column justify-content-around'>
                    <CustomTimePicker
                        title={t('from')}
                        name='fromTime'
                        value={fromValue}
                        handleChange={(newValue) => {
                            setfromValue(newValue);
                        }}
                        disabled={allTime}
                        ampm={false}
                        required
                        id={'fromTime'}
                        actions={['accept', 'cancel']}
                        emptyFields={emptyFields}
                        formatValue={false}
                    />

                    <div className='pt-3'>
                        <CustomTimePicker
                            title={t('to')}
                            name='toTime'
                            value={toValue}
                            handleChange={(newValue) => {
                                if (fromValue && newValue <= fromValue) {
                                    toast.error(t('to_time_greater_than_from'));
                                } else {
                                    setToValue(newValue);
                                }
                            }}
                            disabled={allTime}
                            ampm={false}
                            required
                            id={'fromTime'}
                            actions={['accept', 'cancel']}
                            emptyFields={emptyFields}
                            formatValue={false}
                        />
                    </div>
                </div>
                <div className='p-top-1'>
                    <ButtonNextStep id='btn-ss-add' text={'create'} click={handleCLick} />
                </div>
            </div>
        </div>
    );
};

export default ScheduleSelectorDayTime;
